import * as Sentry from "@sentry/react";

const defaultSentryDSN = "https://8cc455cc4c144c1da566bbbb638b4e0d@o249821.ingest.sentry.io/5884955";

const environments = {
    Dev: 'DEV',
    Test: 'TEST',
    Prod: 'PROD'
};

const getEnvironment = () => {
    if (window.location.hostname === 'local.acefitness.org')
      return environments.Dev;
    else if (window.location.hostname === 'test.acefitness.org')
      return environments.Test;
    else
      return environments.Prod;
  };

const initializeSentry = () => {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN || defaultSentryDSN,
        environment: getEnvironment(),
        debug: getEnvironment() !== environments.Prod,
        normalizeDepth: 5,
        release: `ace-dashboard@${process.env.REACT_APP_DASHBOARD_VERSION || '1.0.0'}`
    });
};

export default initializeSentry;
  